import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  toggle(event) {
    const content = event.currentTarget.nextElementSibling;
    const isOpen = content.classList.contains("hidden");

    // Close all accordions
    this.contentTargets.forEach((el) => el.classList.add("hidden"));

    // Toggle the clicked one
    if (isOpen) {
      content.classList.remove("hidden");
    }
  }
}
